<!-- Story page, where the whole story will display -->
<template lang="html">
<div id="story" class="story" style="">

  <div class="card-story">

      <div>

        <div class="div-story">
          <md-card-header>
              <md-avatar class="avatarProfile">
                <img :src="profile.profileImg">
              </md-avatar>
            <md-card-header-text>
              <div class="md-title link" @click="$router.push({ name: 'profile', params: { id: profile.id }})">{{ profile.fullName }}</div>
              <div class="md-subhead">{{ date(story.createdAt) }}</div>

            </md-card-header-text>

            <menu-tp
              v-if="user && chapter && user.id == chapter.author"
              icon="more_horiz"
              :like="user.id == chapter.author? 'ownChapter' : 'report'"
              :offsetX="-200"
              :offsetY="-50"
              @edit="edit = true"
              @delete="deleteDialog = true"
            />

          </md-card-header>

          <div class="data">
            <div class="dataStory">
              <h3>{{ story.title }}</h3>
              <h3>{{ timePeriod() }}</h3>
            </div>
          </div>

          <div class="textChapter">
            <p v-for="(p, index) in paragraphedContent" :key="index">{{p}}</p>
          </div>
          <!-- {{ story.content }} -->
        </div>

        <create-modal
          :createOn="edit"
          :place="place"
          :chapter="chapter"
          :mode="'edit'"
          @close="edit = $event"
        />

        <md-dialog :md-active.sync="deleteDialog">
          <md-dialog-title>Você tem certeza que deseja deletar esse capítulo?</md-dialog-title>
          <md-dialog-actions>
            <md-button @click="removeChapter()" :disabled="deleteStatus != false">
              <span v-if="!deleteStatus">Sim!</span>
              <loader v-else-if="deleteStatus == 'loading'" />
              <span v-else-if="deleteStatus == 'error'">Erro!</span>
              <span v-else>Deletado!</span>
            </md-button>
            <md-button style="background: lightgrey;" @click="deleteDialog = false">
              Não, tire-me daqui!
            </md-button>
          </md-dialog-actions>
        </md-dialog>

      </div>

  </div>


</div>
</template>

<script>
import LogRocket from "logrocket";
import menuTp from '@/components/shared/menuTemplate';
import loader from '@/components/shared/loader';
import createModal from '@/components/shared/chapter/createModal'
import call from '@/api/calls';
import date from "@/assets/js/date";

const log = (error, method, data) => {
  LogRocket.captureException(error, {
    extra: {
      method,
      data
    }
  });
}

export default {
  name: "story",
  components: {
    menuTp,
    loader,
    createModal
  },
  props: ['place'],
  data() {
    return {
      profile: {
        profileImg: require('@/assets/avatarDefault.png'),
        fullName: 'Nome Sobrenome'
      },
      story: {
        title: "Chapter",
        dateStart: "XX/XX/XXXX",
        content: `
        A escola dos Annales é um movimento historiográfico do século XX que se constituiu em torno do periódico acadêmico francês Annales d'histoire économique et sociale, tendo se destacado por incorporar métodos das Ciências Sociais à História. Fundada por Lucien Febvre e Marc Bloch em 1929, propunha-se a ir além da visão positivista da história como crônica de acontecimentos (histoire événementielle), substituindo o tempo breve da história dos acontecimentos pelos processos de longa duração, com o objetivo de tornar inteligíveis a civilização e as mentalidades. Bloch foi morto pela Gestapo durante a ocupação alemã da França, na Segunda Guerra Mundial, e Febvre seguiu com a abordagem dos Annales nas décadas de 1940 e 1950. Nesse período, orientou Fernand Braudel, que se tornou um dos mais conhecidos expoentes dessa escola. A obra de Braudel definiu uma segunda geração na historiografia dos Annales e foi muito influente nos anos 1960 e 1970, especialmente por sua obra de 1946, O Mediterrâneo e o mundo mediterrânico na época de Felipe II.[1][2] A terceira geração dos Annales é conduzida por Jacques Le Goff e ficou mais conhecida como a Nova História, segundo a qual, toda atividade humana é considerada história. Além de Le Goff, nesse período se destaca Pierre Nora.

        A escola dos Annales renovou e ampliou o quadro das pesquisas históricas ao abrir o campo da História para o estudo de atividades humanas até então pouco investigadas, rompendo com a compartimentação das Ciências Sociais (História, Sociologia, Psicologia, Economia, Geografia humana e assim por diante) e privilegiando os métodos pluridisciplinares.[3]

        Os fundadores do periódico (1929) e do movimento foram os historiadores Marc Bloch e Lucien Febvre, então docentes na Universidade de Estrasburgo. Rapidamente foram associados à abordagem inovadora dos "Annales", que combinava a Geografia, a História e as abordagens sociológicas da "Année Sociologique"[4]. Muitos dos seus colaboradores eram conhecidos em Estrasburgo e reuniam-se para produzir uma análise que rejeitava a ênfase predominante em política, diplomacia e guerras, característica de muitos historiadores dos séculos XIX e XX, liderados pelos "sorbonnistas" - designação dada por Febvre.

        Notavelmente, os Annales trouxeram inovações ao campo historiográfico em vários aspectos, como no conceito de história-problema e na ampliação das fontes. As gerações dos Annales vieram a refletir sobre questões relevantes para o avanço historiográfico e ampliando as possibilidades de análise históricas pensando uma história total ou global.[5][6] A Escola dos Annales elaboram uma nova forma de pensar a construção histórica a partir de uma problemática. Inauguram a chamada história-problema. Apesar de ser divulgado amplamente como uma inovação, o conceito de história-problema, Jacques Revel afirma que os Annales vieram a retomar ideias já existente na obra de Simiand. Assim como a respeito da convergência das ciências humanas, mas com sentido e implicações diferentes.[7] Uma aproximação entre as ciências humanas, acabando com o isolamento em que a história se mantinha, veio a ser importante para a abertura de novas interrogações e a utilização de outros métodos de análise.[8] A questão da interdisciplinariedade presente na Escola dos Annales é apontada por historiadores como Peter Burke como uma grande inovação da Escola dos Annales.[9] Apesar de ser uma inovação dos Annales, Jacques Revel afirma que os metódicos já vinham buscando aproximação da história com outras ciências sociais.[10] Algo que já era feito por Henri Berr.[11] Braudel foi notório na questão da interdisciplinaridade, produziu publicações que uniram em suas análises diversas ciências sociais. Especialmente, com relação à história e a geografia. Sendo destaque o Mediterrâneo e o artigo “Da longa duração”.[12] Os Annales conseguiram efetivar a ideia de interdisciplinaridade que já estava presente em Simiand.[13] Mas diferente de ser uma normativa metodológica, um alinhamento científico, a interdisciplinaridade é utilizada de modo a obtenção de um conhecimento mais amplo.[14]

        Os historiadores dos "Annales" foram os pioneiros na abordagem do estudo de estruturas históricas de longa duração ("la longue durée") para explicar eventos e transformações políticas. Geografia, cultura material e o que posteriormente os "annalistas" chamaram "mentalidades" (ou a psicologia da época) também eram áreas características de estudo.[15]

        Um eminente membro desta escola, Georges Duby, no prefácio de seu livro "O domingo de Bouvines", escreveu que a História que ele ensina, "rejeitada na fronteira do sensacionalismo, era relutante à simples enumeração dos eventos, esforçando-se, ao contrário, por expôr e resolver problemas e, negligenciando as trepidações da superfície, procurava situar no longo e médio prazos a evolução da economia, da sociedade e da civilização."

        Enquanto autores como Emmanuel Le Roy Ladurie e Jacques Le Goff continuam a carregar a bandeira dos "Annales", hoje em dia a sua abordagem tornou-se menos distintiva enquanto mais e mais historiadores trabalham a história cultural e a história econômica.

        Vale lembrar que, enquanto alguns autores, como Peter Burke, consideram a geração de historiadores franceses da geração de Jacques Le Goff em uma perspectiva de continuidade em relação ao movimento dos Annales (e os próprios historiadores deste grupo também se vêem desta maneira), já outros autores - como o François Dosse de A História em Migalhas - procuram enfatizar a ruptura entre a Nova História e o movimento dos Annales de Bloch a Braudel.[16] Para Dosse, por exemplo, o princípio de História Total - tão zelosamente cultivado por Bloch, Febvre e Braudel - teria sido traído por uma perspectiva historiográfica fragmentada, que já seria típica dos historiadores ligados à Nova História.`
      },
      newChapter: {},
      deleteDialog: false,
      deleteStatus: false,
      error: null,
      edit: false
    };
  },
  computed: {
    paragraphedContent() {
      return this.story.content.split("\n");
    },
    user() {
      return JSON.parse(localStorage.getItem('user'));
    },
    chapter() {
      return this.$route.params.chapter;
    }
  },
  mounted() {
    this.getPost();
  },
  methods: {
    getPost() {
      // console.log(this.chapter);
      if(this.chapter) {
        this.story = this.chapter;
        call.profile.getChapterData(this.story.author)
        .then(profile => this.profile = profile)
        .catch(error => {
          log(error, "getPost()", null);
          return this.error = error;
        });
      }
    },
    timePeriod() {
      let period;
      if (process.env.NODE_ENV != 'production' && !this.chapter)
        period = date.timePeriod(new Date(), new Date());
      else  period = date.timePeriod(this.chapter.dateStart, this.chapter.dateEnd);
      if (period && period.full)  return period.full;
      else if (period)  return period.start + " a " + period.end;
      else  return period;
    },
    date(literalDate) {
      let locale = "pt-BR";
      if(literalDate)
        return new Date(literalDate).toLocaleDateString(locale);
      return null
    },
    removeChapter() {
      this.deleteStatus = "loading";
      call.chapter.remove(this.$route.params.id, this.user.id)
      .then(() => {
        this.deleteStatus = true;
        // removed: null or chapter
        // this.log(removed);
        this.$router.back();
      })
      .catch(error => {
        this.deleteStatus = "error";
        log(error, "removeChapter()", null);
        this.error = error;
        // return this.log(error);
      });
    },
    log(message) {
      console.log(message); // eslint-disable-line no-console
    }
  }
};
</script>

<style scoped>
#navbar-story {
  background-color: #57aa9a;
}

.avatarProfile{
  width: 3em;
  height: 3em;
}

.profileStory{
  background-color: blue;
}

.div-imagem-profile {
  width: 306px;
  height: 50px;
  /* background-color: blue; */
}

.img-profile {
  margin: 4px 10px;
  /* text-align: center; */
}

.link {
  cursor: pointer;
}

.dataStory {
  top: 50%;
  padding-left: 5px;
  text-align: center;
  word-break: break-word;
}

.div-story {
  position: relative;
  float: left;
  min-width: 100%;
  max-height: 34em;
  overflow-y: auto;

  /* margin-right: 2px; */
  background-color: #fff;
}

.textChapter{
  position: relative;
  min-width: 100%;
  word-break: break-word;
}

.button-send {
  position: relative;
  bottom: 0px;
}

/* .md-scrollbar::-webkit-scrollbar{
  width:12px;
  height:0px;
  border-radius:0
}
.md-scrollbar::-webkit-scrollbar-thumb{
  border-radius:0px
}
.md-scrollbar::-webkit-scrollbar-button{
  display:none;
}
.md-scrollbar.md-theme-default::-webkit-scrollbar-corner,.md-scrollbar.md-theme-default::-webkit-scrollbar-track{
  background:#e1e1e1;
  background:var(--md-theme-default-scrollbar-background-on-background-variant, #e1e1e1)
}
.md-scrollbar.md-theme-default::-webkit-scrollbar-thumb{
  background:#2196f3;
  background:var(--md-theme-default-scrollbar-on-background-variant, #2196f3)
} */

@media (max-width: 1062px) {
  .div-story {
    width: 150px;
  }
}
</style>
